export const HEALTH_REPORT_FAILURE_GUIDANCE = {
  rendering: "The report could not be rendered. Retry once. If it fails again, ask support to check report rendering; do not send health data.",
  storage: "The report PDF could not be saved. Try again later. You do not need to upload the sources again.",
  stale_review: "The reviewed evidence changed. Refresh or re-extract the evidence, then review it before generating again.",
  temporary_service: "A required service could not complete the request. Wait a few minutes and retry.",
  review_required: "Review the evidence explicitly before generating the report.",
  generation_in_progress: "Generation is already in progress. Wait for it to finish and refresh the report.",
  case_unavailable: "This case cannot be generated in its current state. Refresh it and check whether it was cleaned or changed.",
  generation_failed: "Retry once. If it fails again, ask support to investigate using the case ID, without sharing health data.",
} as const;

export type HealthReportFailureCode = keyof typeof HEALTH_REPORT_FAILURE_GUIDANCE;

export function safeHealthReportFailureCode(value: unknown): HealthReportFailureCode | null {
  return typeof value === "string" && Object.hasOwn(HEALTH_REPORT_FAILURE_GUIDANCE, value)
    ? value as HealthReportFailureCode
    : null;
}

export function healthReportFailureGuidance(value: unknown): string {
  return HEALTH_REPORT_FAILURE_GUIDANCE[safeHealthReportFailureCode(value) ?? "generation_failed"];
}

export function healthReportGenerationErrorGuidance(error: unknown): string {
  if (error && typeof error === "object" && "responseBody" in error) {
    try {
      const body = JSON.parse(String(error.responseBody)) as { reasonCode?: unknown };
      return healthReportFailureGuidance(body?.reasonCode);
    } catch {
      // Transport and legacy errors must not be rendered verbatim.
    }
  }
  return healthReportFailureGuidance(null);
}
